export const getBrowserInfo = () => {
  if (typeof window === "undefined") return "unknown";

  const userAgent = window.navigator.userAgent;
  const browsers = [
    { name: "Edge", value: "Edge" },
    { name: "Chrome", value: "Chrome" },
    { name: "Firefox", value: "Firefox" },
    { name: "Safari", value: "Safari" },
    { name: "Opera", value: "Opera" },
  ];

  for (const browser of browsers) {
    if (userAgent.indexOf(browser.value) > -1) {
      return browser.name;
    }
  }

  return "unknown";
};
